import { Grid, Typography, Box, TextField } from "@mui/material"
import { useAppSelector } from "../../../hooks/store-hooks"
import { usePasswordRecoveryService } from "../../../../use-cases/auth/usePasswordRecoveryService"

export const CreateNewPasswordForm = () => {
  const createNewPasswordForm = useAppSelector((state) => state.auth.createNewPasswordForm)
  const {
    setCreateNewPasswordFormPassword,
    setCreateNewPasswordFormConfirmPassword
  } = usePasswordRecoveryService()
  return <>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h5" component="h1" align="center" color="primary" fontWeight="bold">
          Recuperar senha
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" component="p" align="center">
          Insira a nova senha que deseja usar para acessar sua conta no campo de texto abaixo e clique em "Finalizar". Em seguida, você será redirecionado para a página de login.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Box mt={3}>
          <Typography variant="body1" component="p" align="center" fontWeight="bold">
            Lembre-se de seguir todas as instruções fornecidas pelo sistema para garantir a segurança da sua conta. Se você tiver problemas para recuperar sua senha, entre em contato com o suporte ao cliente para obter ajuda adicional.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Nova senha"
          value={createNewPasswordForm.fields.password}
          onChange={(e) => {
            setCreateNewPasswordFormPassword({
              password: e.target.value
            })
          }}
          error={Boolean(createNewPasswordForm.touched && createNewPasswordForm.errors.find(item => item.key === 'password'))}
          helperText={
            <div dangerouslySetInnerHTML={{
              __html: createNewPasswordForm.errors.find(item => item.key === 'password')?.message ?? ''
            }}>
            </div>
          }
          name="new-password"
          fullWidth
          id="new-password"
          autoFocus
          type="password"
        />

      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Confirmar nova senha"
          value={createNewPasswordForm.fields.confirmPassword}
          onChange={(e) => {
            setCreateNewPasswordFormConfirmPassword({
              confirmPassword: e.target.value
            })
          }}
          error={Boolean(createNewPasswordForm.touched && createNewPasswordForm.errors.find(item => item.key === 'confirmPassword'))}
          helperText={
            createNewPasswordForm.errors.find(item => item.key === 'confirmPassword')?.message
          }
          name="confirm-new-password"
          fullWidth
          id="confirm-new-password"
          type="password"
        />
      </Grid>
    </Grid>
  </>
}